document.addEventListener('DOMContentLoaded', function() {
    const sticky = document.querySelector('#StickyBuyBar');
    if (!sticky) return;

    // --- Function to update variant ID & price in sticky bar ---
    function updateStickyBar(variantId) {
    if (!variantId) return;

    // Update hidden variant inputs in sticky buy bar
    const navVariantInputs = sticky.querySelectorAll('input[name="id"]');
    navVariantInputs.forEach(input => input.value = variantId);

    // Update price display
    const price = window.variantPrices?.[variantId];
    if (price) {
        const button = sticky.querySelector('.eva-submit-button-span');
        if (button) {
        button.setAttribute('data-total', price);
        button.textContent = 'Add to cart - $' + price;
        }
    }
    }

    // --- Default load: get selected variant from main product form ---
    const mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
    const selectedVariantInput = mainForm?.querySelector('input[name="id"]');
    if (selectedVariantInput) updateStickyBar(selectedVariantInput.value);

    // --- Listen for variant/configuration changes ---
    document.addEventListener('change', function(event) {
    const target = event.target;
    if (target.name === 'id' || target.name === 'Configuration') {
        const parentForm = target.closest('form');
        if (parentForm && !sticky.contains(parentForm)) {
        const variantId = target.name === 'id'
            ? target.value
            : parentForm.querySelector('input[name="id"]').value;
        updateStickyBar(variantId);
        }
    }
    }, true);
});
